import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getEntrevistasOC = query =>
	fetch.get(
		`/entrevistas-oc${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getEntrevistaOC = ({ id, query }) =>
	fetch.get(`/entrevistas-oc/${id}${
		query
			? `?${qs.stringify(
					{ ...query, publicationState: 'live' },
					{
						encodeValuesOnly: true,
					}
			  )}`
			: ''
	}
`);
export const addEntrevistaOC = data => fetch.post('/entrevistas-oc', data);
export const updateEntrevistaOC = ({ id, ...data }) =>
	fetch.put(`/entrevistas-oc/${id}`, data);
export const deleteEntrevistaOC = id => fetch.delete(`/entrevistas-oc/${id}`);

// RTK Query
export const entrevistasOCApi = createApi({
	reducerPath: 'entrevistasOCApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getEntrevistasOC: build.query({
			query: query => {
				return {
					url: `/entrevistas-oc${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'EntrevistasOC',
								id,
							})),
							{ type: 'EntrevistasOC', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'EntrevistasOC', id: 'LIST' }],
		}),
		getEntrevistaOC: build.query({
			query: ({ id, query }) => {
				return {
					url: `/entrevistas-oc/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'EntrevistasOC', id }],
		}),
		addEntrevistaOC: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/entrevistas-oc`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Entrevista OC agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar entrevista oc');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'EntrevistasOC', id: 'LIST' }],
		}),
		updateEntrevistaOC: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/entrevistas-oc/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Entrevista OC actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar entrevista oc');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'EntrevistasOC', id },
			],
		}),
		deleteEntrevistaOC: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/entrevistas-oc/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Entrevista OC eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar entrevista oc');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'EntrevistasOC', id },
			],
		}),
	}),
});

export const {
	useGetEntrevistasOCQuery,
	useGetEntrevistaOCQuery,
	useAddEntrevistaOCMutation,
	useUpdateEntrevistaOCMutation,
	useDeleteEntrevistaOCMutation,
} = entrevistasOCApi;
